
















import JUserSelectPanel from "@/general/components/pages/parts/ThanksPointUserSelection/JUserSelectPanel.vue";
import { Prop, Vue, Component } from "vue-property-decorator";

@Component({
  components: {
    JUserSelectPanel
  }
})
export default class JUserSelectList extends Vue {
  @Prop({ type: Array, required: true }) userSelectList!: any;

  emitOpenModal(value: any) {
    this.$emit("open-modal", value);
  }
}
